/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, ReactNode} from 'react'
import {useKTable} from '../../../contexts/KTableProvider'
import {KTSVG} from '../../../../../_metronic/helpers'
import {Tooltip} from 'react-tooltip'
import Select from 'react-select'

type KTablePaginationProps = {
  showPageSizeSelector?: boolean
  leftActions?: ReactNode
  rightActions?: ReactNode
  arrowsNextToPageSize?: boolean
}

const PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 500, 2000, 5000]

const KTablePagination: FC<KTablePaginationProps> = ({
  showPageSizeSelector = false,
  leftActions,
  rightActions,
  arrowsNextToPageSize = false,
}) => {
  const {pagination, setPagination, loading} = useKTable()
  const totalResults = pagination.totalResults
  const fromResult = totalResults === 0 ? 0 : (pagination.currentPage - 1) * pagination.perPage + 1
  const toResult = pagination.currentPage * pagination.perPage
  const auxResult = toResult > pagination.totalResults ? pagination.totalResults : toResult
  const lastPage = Math.ceil(pagination.totalResults / pagination.perPage)

  const updatePage = (page: number) => {
    if (page < 1) return
    if (page > lastPage) return
    setPagination({...pagination, currentPage: page})
  }

  const handlePerPageChange = (value: number) => {
    if (value === pagination.perPage) return
    setPagination({...pagination, perPage: value, currentPage: 1})
  }

  const paginationArrows = (
    <ul className='pagination d-flex align-items-center mb-0'>
      <li
        key={'pagination-first'}
        className={clsx('page-item', {
          disabled: loading || pagination.currentPage === 1,
        })}
        id='first-tooltip'
      >
        <a
          className='page-link border border-gray-400'
          style={{cursor: 'pointer'}}
          onClick={() => updatePage(1)}
        >
          <KTSVG
            path='/media/icons/duotune/arrows/arr025.svg'
            className=' svg-icon-2 svg-icon-gray-400'
          />
        </a>
      </li>
      <Tooltip anchorSelect='#first-tooltip' content='Primera Página' />
      <li
        key={'pagination-prev'}
        className={clsx('page-item', {
          disabled: loading || pagination.currentPage === 1,
        })}
        id='prev-tooltip'
      >
        <a
          className='page-link border border-gray-400'
          style={{cursor: 'pointer'}}
          onClick={() => updatePage(pagination.currentPage - 1)}
        >
          <KTSVG
            path='/media/icons/duotune/arrows/arr026.svg'
            className=' svg-icon-2 svg-icon-gray-400'
          />
        </a>
      </li>
      <Tooltip anchorSelect='#prev-tooltip' content='Página Anterior' />
      <li
        key={'pagination-next'}
        className={clsx('page-item', {
          disabled: loading || pagination.currentPage === lastPage,
        })}
        id='next-tooltip'
      >
        <a
          className='page-link border border-gray-400'
          style={{cursor: 'pointer'}}
          onClick={() => updatePage(pagination.currentPage + 1)}
        >
          <KTSVG
            path='/media/icons/duotune/arrows/arr027.svg'
            className=' svg-icon-2 svg-icon-gray-400'
          />
        </a>
      </li>
      <Tooltip anchorSelect='#next-tooltip' content='Siguiente Página' />
      <li
        key={'pagination-last'}
        className={clsx('page-item', {
          disabled: loading || pagination.currentPage === lastPage,
        })}
        id='last-tooltip'
      >
        <a
          className='page-link border border-gray-400'
          style={{cursor: 'pointer'}}
          onClick={() => updatePage(lastPage)}
        >
          <KTSVG
            path='/media/icons/duotune/arrows/arr028.svg'
            className=' svg-icon-2 svg-icon-gray-400'
          />
        </a>
      </li>
      <Tooltip anchorSelect='#last-tooltip' content='Última Página' />
      {/* <li
              key={'pagination-reload'}
              className={clsx('page-item', {
                disabled: loading,
              })}
              id='reloading-tooltip'
            >
              <a
                className='page-link border border-gray-400'
                style={{ cursor: 'pointer' }}
              // onClick={() => updatePage(1)}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr058.svg'
                  className=' svg-icon-2 svg-icon-black'
                />
              </a>
            </li>
            <Tooltip anchorSelect='#reloading-tooltip' content='Recargar Pagina' /> */}
    </ul>
  )

  return (
    <div className='row d-flex align-items-center mb-4 user-select-none gap-sm-3 gap-md-0 gap-lg-0'>
      <div
        className={clsx('d-flex align-items-center justify-content-md-start', {
          'col-sm-12 col-md-5': !arrowsNextToPageSize,
          'col-sm-12 col-md-3': arrowsNextToPageSize,
        })}
      >
        {arrowsNextToPageSize ? (
          leftActions ?? <div />
        ) : (
          <div id='kt_table_paginate'>{paginationArrows}</div>
        )}
      </div>
      <div
        className={clsx('d-flex align-items-center justify-content-md-end', {
          'col-sm-12 col-md-7': !arrowsNextToPageSize,
          'col-sm-12 col-md-9': arrowsNextToPageSize,
        })}
      >
        <div className='d-flex justify-content-center align-items-center gap-3'>
          {showPageSizeSelector && (
            <div className='d-flex align-items-center gap-2'>
              <span>Filas:</span>
              {/* <select
                className='form-select form-select-sm w-auto'
                value={pagination.perPage}
                onChange={(e) => handlePerPageChange(Number(e.target.value))}
                disabled={loading}
              >
                {PAGE_SIZE_OPTIONS.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select> */}
              <Select
                isDisabled={loading}
                options={[...PAGE_SIZE_OPTIONS].map((option) => ({value: option, label: option}))}
                value={{value: pagination.perPage, label: pagination.perPage}}
                onChange={(selectedOption) => {
                  if (!selectedOption) return
                  handlePerPageChange(selectedOption.value)
                }}
                menuPortalTarget={document.body}
                menuPosition='fixed'
                menuPlacement='auto'
                isSearchable={false}
                classNamePrefix='react-select'
                styles={{
                  container: (base) => ({
                    ...base,
                    minWidth: 90,
                  }),
                  control: (base) => ({
                    ...base,
                    minHeight: 31,
                    height: 31,
                    borderColor: '#E4E6EF',
                    boxShadow: 'none',
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: 31,
                    padding: '0 8px',
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                  }),
                  indicatorsContainer: (base) => ({
                    ...base,
                    height: 31,
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            </div>
          )}
          {arrowsNextToPageSize && <div id='kt_table_paginate'>{paginationArrows}</div>}
          {rightActions}
          <div>{`Mostrando de ${fromResult} al ${auxResult} de ${totalResults} resultados`}</div>
        </div>
      </div>
    </div>
  )
}

export {KTablePagination}
